import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

export default function LegalPage() {
  return (
    <div className="min-h-screen pt-20" data-testid="legal-page">
      <Helmet>
        <title>Mentions Légales | École de Musique Pour Tous - Périgueux</title>
        <meta name="description" content="Mentions légales de l'École de Musique Pour Tous à Périgueux. Informations sur l'éditeur, l'hébergement et les conditions d'utilisation du site." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://ecoledemusiqueperigueux.fr/mentions-legales" />
      </Helmet>
      <section className="py-16 bg-cream">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="font-dancing text-5xl text-burgundy mb-8">
              Mentions légales
            </h1>

            <div className="bg-white rounded-3xl shadow-sm p-8 space-y-8 font-nunito">
              <section>
                <h2 className="font-bold text-xl text-burgundy mb-4">1. Éditeur du site</h2>
                <p className="text-gray-700 leading-relaxed">
                  <strong>École de Musique Pour Tous</strong><br />
                  Charlotte Naboulet - Enseignante référente<br />
                  Professeur de musique - Auto-entrepreneur<br /><br />
                  <strong>Adresse :</strong> 2 Rue Ludovic Trarieux, 24000 Périgueux, France<br />
                  <strong>Téléphone :</strong> <a href="tel:+33649523778" className="text-burgundy hover:underline">06 49 52 37 78</a><br />
                  <strong>Email :</strong> <a href="mailto:musiquepourtous24@gmail.com" className="text-burgundy hover:underline">musiquepourtous24@gmail.com</a>
                </p>
              </section>

              <section>
                <h2 className="font-bold text-xl text-burgundy mb-4">2. Hébergement</h2>
                <p className="text-gray-700 leading-relaxed">
                  Ce site est hébergé par Emergent Agent.<br />
                  Les données sont stockées sur des serveurs sécurisés.
                </p>
              </section>

              <section>
                <h2 className="font-bold text-xl text-burgundy mb-4">3. Propriété intellectuelle</h2>
                <p className="text-gray-700 leading-relaxed">
                  L'ensemble du contenu de ce site (textes, images, logos, graphismes) est la propriété 
                  exclusive de l'École de Musique Pour Tous, sauf mention contraire. Toute reproduction, 
                  représentation, modification, publication, adaptation de tout ou partie des éléments 
                  du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation 
                  écrite préalable.
                </p>
              </section>

              <section>
                <h2 className="font-bold text-xl text-burgundy mb-4">4. Responsabilité</h2>
                <p className="text-gray-700 leading-relaxed">
                  L'École de Musique Pour Tous s'efforce de fournir des informations exactes et à jour sur ce site. 
                  Toutefois, elle ne peut garantir l'exactitude, la précision ou l'exhaustivité des 
                  informations mises à disposition. En conséquence, l'École de Musique Pour Tous décline toute 
                  responsabilité pour toute imprécision, inexactitude ou omission portant sur des 
                  informations disponibles sur ce site.
                </p>
              </section>

              <section>
                <h2 className="font-bold text-xl text-burgundy mb-4">5. Liens hypertextes</h2>
                <p className="text-gray-700 leading-relaxed">
                  Ce site peut contenir des liens hypertextes vers d'autres sites. Charlotte Naboulet 
                  n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur 
                  contenu.
                </p>
              </section>

              <section>
                <h2 className="font-bold text-xl text-burgundy mb-4">6. Droit applicable</h2>
                <p className="text-gray-700 leading-relaxed">
                  Le présent site et les mentions légales qui y figurent sont régis par le droit français. 
                  Tout litige relatif à l'utilisation du site sera soumis à la compétence exclusive des 
                  tribunaux français.
                </p>
              </section>

              <section>
                <h2 className="font-bold text-xl text-burgundy mb-4">7. Crédits photos</h2>
                <p className="text-gray-700 leading-relaxed">
                  Les photos utilisées sur ce site proviennent d'Unsplash et sont libres de droits.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
